import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  SEALED_getInstance2urch17m532zf as SEALED_getInstance,
  STRING_getInstance3lkmlozu5h7cs as STRING_getInstance,
  ENUM_getInstance3ph4fa6o285vr as ENUM_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  JsonElementf07o4p6p57al as JsonElement,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
  JsonNull_getInstancehlive1cpt4pr as JsonNull_getInstance,
  JsonNull2liwjj96vm0w2 as JsonNull,
} from './JsonElement.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  minify1kh64osmcox7j as minify,
  access$formatDecodingException$tJsonExceptionsKt2yfifxvnjk03f as access$formatDecodingException$tJsonExceptionsKt,
  decodingExceptionOf183k4uqzusb49 as decodingExceptionOf,
} from './internal/JsonExceptions.mjs';
import { JsonDecodingExceptionoyag1psadwuw as JsonDecodingException } from './JsonExceptions.mjs';
import { toLongOrNullutqivezb0wx1 as toLongOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { toULongOrNullojoyxi0i9tgj as toULongOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import {
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance2ln0tj1crqgxz as Companion_getInstance,
  _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  serializer2lw83vwvpnyms as serializer,
  serializer1x79l67jvwntn as serializer_0,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringCompanionObject_instance1v0ht40fz3tq0 as StringCompanionObject_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { JsonDecoder1rijst5ne6qla as JsonDecoder } from './JsonDecoder.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from './JsonEncoder.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.t1n('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.t1n('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.t1n('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.t1n('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.t1n('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().r2p_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().s2p_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().t2p_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().u2p_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().v2p_1;
}
var JsonElementSerializerClass;
function JsonElementSerializer() {
  if (JsonElementSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonElementSerializer_instance = this;
        var tmp = this;
        var tmp_0 = SEALED_getInstance();
        tmp.w2p_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
      }
      a1n() {
        return this.w2p_1;
      }
      x2p(encoder, value) {
        verify(encoder);
        if (value instanceof JsonPrimitive()) {
          encoder.k1t(JsonPrimitiveSerializer_getInstance(), value);
        } else {
          if (value instanceof JsonObject()) {
            encoder.k1t(JsonObjectSerializer_getInstance(), value);
          } else {
            if (value instanceof JsonArray()) {
              encoder.k1t(JsonArraySerializer_getInstance(), value);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      b1n(encoder, value) {
        return this.x2p(encoder, value instanceof JsonElement() ? value : THROW_CCE());
      }
      c1n(decoder) {
        var input = asJsonDecoder(decoder);
        return input.z2o();
      }
    }
    initMetadataForObject($, 'JsonElementSerializer', VOID, VOID, [KSerializer()]);
    JsonElementSerializerClass = $;
  }
  return JsonElementSerializerClass;
}
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance === VOID)
    new (JsonElementSerializer())();
  return JsonElementSerializer_instance;
}
function defer(deferred) {
  return new (defer$1())(deferred);
}
var JsonPrimitiveSerializerClass;
function JsonPrimitiveSerializer() {
  if (JsonPrimitiveSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonPrimitiveSerializer_instance = this;
        this.r2p_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
      }
      a1n() {
        return this.r2p_1;
      }
      y2p(encoder, value) {
        verify(encoder);
        var tmp;
        if (value instanceof JsonNull()) {
          encoder.k1t(JsonNullSerializer_getInstance(), JsonNull_getInstance());
          tmp = Unit_instance;
        } else {
          var tmp_0 = JsonLiteralSerializer_getInstance();
          encoder.k1t(tmp_0, value instanceof JsonLiteral() ? value : THROW_CCE());
          tmp = Unit_instance;
        }
        return tmp;
      }
      b1n(encoder, value) {
        return this.y2p(encoder, value instanceof JsonPrimitive() ? value : THROW_CCE());
      }
      c1n(decoder) {
        var jsonDecoder = asJsonDecoder(decoder);
        var result = jsonDecoder.z2o();
        if (!(result instanceof JsonPrimitive())) {
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var shortMessage = 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result));
          var tmp;
          if (jsonDecoder.y2o().t2m_1.x2o_1) {
            var tmp$ret$3 = toString(result);
            tmp = toString(minify(tmp$ret$3));
          } else {
            tmp = null;
          }
          var inputValue = tmp;
          throw JsonDecodingException().l2q(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue), shortMessage, -1, null, inputValue, null);
        }
        return result;
      }
    }
    initMetadataForObject($, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer()]);
    JsonPrimitiveSerializerClass = $;
  }
  return JsonPrimitiveSerializerClass;
}
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance === VOID)
    new (JsonPrimitiveSerializer())();
  return JsonPrimitiveSerializer_instance;
}
var JsonNullSerializerClass;
function JsonNullSerializer() {
  if (JsonNullSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonNullSerializer_instance = this;
        this.s2p_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
      }
      a1n() {
        return this.s2p_1;
      }
      m2q(encoder, value) {
        verify(encoder);
        encoder.n1s();
      }
      b1n(encoder, value) {
        return this.m2q(encoder, value instanceof JsonNull() ? value : THROW_CCE());
      }
      c1n(decoder) {
        verify_0(decoder);
        if (decoder.c1r()) {
          throw decodingExceptionOf("Expected 'null' literal");
        }
        decoder.d1r();
        return JsonNull_getInstance();
      }
    }
    initMetadataForObject($, 'JsonNullSerializer', VOID, VOID, [KSerializer()]);
    JsonNullSerializerClass = $;
  }
  return JsonNullSerializerClass;
}
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance === VOID)
    new (JsonNullSerializer())();
  return JsonNullSerializer_instance;
}
var JsonLiteralSerializerClass;
function JsonLiteralSerializer() {
  if (JsonLiteralSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonLiteralSerializer_instance = this;
        this.t2p_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
      }
      a1n() {
        return this.t2p_1;
      }
      n2q(encoder, value) {
        verify(encoder);
        if (value.j2p_1) {
          return encoder.w1s(value.l2p_1);
        }
        if (!(value.k2p_1 == null)) {
          return encoder.y1s(value.k2p_1).w1s(value.l2p_1);
        }
        var tmp0_safe_receiver = toLongOrNull(value.l2p_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return encoder.s1s(tmp0_safe_receiver);
        }
        var tmp1_safe_receiver = toULongOrNull(value.l2p_1);
        var tmp = tmp1_safe_receiver;
        if ((tmp == null ? null : new (ULong())(tmp)) == null)
          null;
        else {
          var tmp_0 = tmp1_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_0 == null ? null : new (ULong())(tmp_0)).bv_1;
          var tmp_1 = encoder.y1s(serializer(Companion_getInstance()).a1n());
          // Inline function 'kotlin.ULong.toLong' call
          var tmp$ret$4 = _ULong___get_data__impl__fggpzb(it);
          tmp_1.s1s(tmp$ret$4);
          return Unit_instance;
        }
        var tmp2_safe_receiver = toDoubleOrNull(value.l2p_1);
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return encoder.u1s(tmp2_safe_receiver);
        }
        var tmp3_safe_receiver = toBooleanStrictOrNull(value.l2p_1);
        if (tmp3_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return encoder.o1s(tmp3_safe_receiver);
        }
        encoder.w1s(value.l2p_1);
      }
      b1n(encoder, value) {
        return this.n2q(encoder, value instanceof JsonLiteral() ? value : THROW_CCE());
      }
      c1n(decoder) {
        var jsonDecoder = asJsonDecoder(decoder);
        var result = jsonDecoder.z2o();
        if (!(result instanceof JsonLiteral())) {
          // Inline function 'kotlinx.serialization.json.internal.decodingExceptionOf' call
          var shortMessage = 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result));
          var tmp;
          if (jsonDecoder.y2o().t2m_1.x2o_1) {
            var tmp$ret$3 = toString(result);
            tmp = toString(minify(tmp$ret$3));
          } else {
            tmp = null;
          }
          var inputValue = tmp;
          throw JsonDecodingException().l2q(access$formatDecodingException$tJsonExceptionsKt(-1, shortMessage, null, null, inputValue), shortMessage, -1, null, inputValue, null);
        }
        return result;
      }
    }
    initMetadataForObject($, 'JsonLiteralSerializer', VOID, VOID, [KSerializer()]);
    JsonLiteralSerializerClass = $;
  }
  return JsonLiteralSerializerClass;
}
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance === VOID)
    new (JsonLiteralSerializer())();
  return JsonLiteralSerializer_instance;
}
var JsonObjectDescriptorClass;
function JsonObjectDescriptor() {
  if (JsonObjectDescriptorClass === VOID) {
    class $ {
      constructor() {
        JsonObjectDescriptor_instance = this;
        this.o2q_1 = MapSerializer(serializer_0(StringCompanionObject_instance), JsonElementSerializer_getInstance()).a1n();
        this.p2q_1 = 'kotlinx.serialization.json.JsonObject';
      }
      d1o() {
        return this.p2q_1;
      }
      a1q(index) {
        return this.o2q_1.a1q(index);
      }
      b1q(name) {
        return this.o2q_1.b1q(name);
      }
      c1q(index) {
        return this.o2q_1.c1q(index);
      }
      d1q(index) {
        return this.o2q_1.d1q(index);
      }
      e1q(index) {
        return this.o2q_1.e1q(index);
      }
      w1p() {
        return this.o2q_1.w1p();
      }
      p1p() {
        return this.o2q_1.p1p();
      }
      x1p() {
        return this.o2q_1.x1p();
      }
      y1p() {
        return this.o2q_1.y1p();
      }
      z1p() {
        return this.o2q_1.z1p();
      }
    }
    initMetadataForObject($, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor()]);
    JsonObjectDescriptorClass = $;
  }
  return JsonObjectDescriptorClass;
}
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance === VOID)
    new (JsonObjectDescriptor())();
  return JsonObjectDescriptor_instance;
}
var JsonObjectSerializerClass;
function JsonObjectSerializer() {
  if (JsonObjectSerializerClass === VOID) {
    class $ {
      constructor() {
        JsonObjectSerializer_instance = this;
        this.u2p_1 = JsonObjectDescriptor_getInstance();
      }
      a1n() {
        return this.u2p_1;
      }
      q2q(encoder, value) {
        verify(encoder);
        MapSerializer(serializer_0(StringCompanionObject_instance), JsonElementSerializer_getInstance()).b1n(encoder, value);
      }
      b1n(encoder, value) {
        return this.q2q(encoder, value instanceof JsonObject() ? value : THROW_CCE());
      }
      c1n(decoder) {
        verify_0(decoder);
        return new (JsonObject())(MapSerializer(serializer_0(StringCompanionObject_instance), JsonElementSerializer_getInstance()).c1n(decoder));
      }
    }
    initMetadataForObject($, 'JsonObjectSerializer', VOID, VOID, [KSerializer()]);
    JsonObjectSerializerClass = $;
  }
  return JsonObjectSerializerClass;
}
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance === VOID)
    new (JsonObjectSerializer())();
  return JsonObjectSerializer_instance;
}
var JsonArrayDescriptorClass;
function JsonArrayDescriptor() {
  if (JsonArrayDescriptorClass === VOID) {
    class $ {
      constructor() {
        JsonArrayDescriptor_instance = this;
        this.r2q_1 = ListSerializer(JsonElementSerializer_getInstance()).a1n();
        this.s2q_1 = 'kotlinx.serialization.json.JsonArray';
      }
      d1o() {
        return this.s2q_1;
      }
      a1q(index) {
        return this.r2q_1.a1q(index);
      }
      b1q(name) {
        return this.r2q_1.b1q(name);
      }
      c1q(index) {
        return this.r2q_1.c1q(index);
      }
      d1q(index) {
        return this.r2q_1.d1q(index);
      }
      e1q(index) {
        return this.r2q_1.e1q(index);
      }
      w1p() {
        return this.r2q_1.w1p();
      }
      p1p() {
        return this.r2q_1.p1p();
      }
      x1p() {
        return this.r2q_1.x1p();
      }
      y1p() {
        return this.r2q_1.y1p();
      }
      z1p() {
        return this.r2q_1.z1p();
      }
    }
    initMetadataForObject($, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor()]);
    JsonArrayDescriptorClass = $;
  }
  return JsonArrayDescriptorClass;
}
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance === VOID)
    new (JsonArrayDescriptor())();
  return JsonArrayDescriptor_instance;
}
var JsonArraySerializerClass;
function JsonArraySerializer() {
  if (JsonArraySerializerClass === VOID) {
    class $ {
      constructor() {
        JsonArraySerializer_instance = this;
        this.v2p_1 = JsonArrayDescriptor_getInstance();
      }
      a1n() {
        return this.v2p_1;
      }
      t2q(encoder, value) {
        verify(encoder);
        ListSerializer(JsonElementSerializer_getInstance()).b1n(encoder, value);
      }
      b1n(encoder, value) {
        return this.t2q(encoder, value instanceof JsonArray() ? value : THROW_CCE());
      }
      c1n(decoder) {
        verify_0(decoder);
        return new (JsonArray())(ListSerializer(JsonElementSerializer_getInstance()).c1n(decoder));
      }
    }
    initMetadataForObject($, 'JsonArraySerializer', VOID, VOID, [KSerializer()]);
    JsonArraySerializerClass = $;
  }
  return JsonArraySerializerClass;
}
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance === VOID)
    new (JsonArraySerializer())();
  return JsonArraySerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder()) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().o('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder()) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().o('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.u2q_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
  return tmp0.n3();
}
function defer$o$_get_original_$ref_3cje7k() {
  return (p0) => _get_original__l7ku1m(p0);
}
var defer$1Class;
function defer$1() {
  if (defer$1Class === VOID) {
    class $ {
      constructor($deferred) {
        this.u2q_1 = lazy($deferred);
      }
      d1o() {
        return _get_original__l7ku1m(this).d1o();
      }
      w1p() {
        return _get_original__l7ku1m(this).w1p();
      }
      y1p() {
        return _get_original__l7ku1m(this).y1p();
      }
      a1q(index) {
        return _get_original__l7ku1m(this).a1q(index);
      }
      b1q(name) {
        return _get_original__l7ku1m(this).b1q(name);
      }
      c1q(index) {
        return _get_original__l7ku1m(this).c1q(index);
      }
      d1q(index) {
        return _get_original__l7ku1m(this).d1q(index);
      }
      e1q(index) {
        return _get_original__l7ku1m(this).e1q(index);
      }
    }
    protoOf($).p1p = get_isNullable;
    protoOf($).x1p = get_isInline;
    protoOf($).z1p = get_annotations;
    initMetadataForClass($, VOID, VOID, VOID, [SerialDescriptor()]);
    defer$1Class = $;
  }
  return defer$1Class;
}
//region block: exports
export {
  JsonArraySerializer_getInstance as JsonArraySerializer_getInstance363y52pmd0j2p,
  JsonElementSerializer_getInstance as JsonElementSerializer_getInstance78doow9tocv6,
  JsonNullSerializer_getInstance as JsonNullSerializer_getInstance2y1iyo7s4gp2x,
  JsonObjectSerializer_getInstance as JsonObjectSerializer_getInstance3ny2swi7cl9nx,
  JsonPrimitiveSerializer_getInstance as JsonPrimitiveSerializer_getInstance4014jlq1v98x,
};
//endregion

//# sourceMappingURL=JsonElementSerializers.mjs.map
